export const CONTACTS_PAGINATION_LIMIT = 10;
export const CONTACT_PROVIDER_ZOIPER5 = 'zoiper5';
